import PropTypes from "prop-types"

const box = {
  boxIndex: PropTypes.number.isRequired,
  employeeCount: PropTypes.number.isRequired,
  percentOfTotal: PropTypes.number.isRequired,
  boxTitle: PropTypes.string.isRequired,
}

const NineBoxGridSummaryShape = {
  reviewId: PropTypes.number.isRequired,
  boxes: PropTypes.arrayOf(PropTypes.shape(box)).isRequired,
  totalEmployees: PropTypes.number.isRequired,
}

export default NineBoxGridSummaryShape



// WEBPACK FOOTER //
// ./src/state/shapes/NineBoxGridSummaryShape.js